import type { $Fetch } from 'nitropack';
import type { BFFResponse } from '~/types/BFFResponse';
import type { Order } from '~/types/GraphQL';

export default ($fetch: $Fetch) => {
  const check = (email: string) => $fetch<BFFResponse<Order>>(`/newsletter/check/${encodeURIComponent(email)}`);

  return {
    check,
  };
};
